import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './inserir-banner.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Tooltip,
  IconButton,
  Radio,
  RadioGroup,
  TagLabel,
  Tag,
  Wrap,
  TagCloseButton,
  WrapItem,
} from '@chakra-ui/react';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/banner';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { listarExecutores } from '../../../../api/noticia';
import { obterUsuario } from '../../../../api/usuario';
import { MdInfoOutline } from 'react-icons/md';
import { ImageDropzoneMax500mb } from '../../../../components/common/imageDropzoneMax500mb/imageDropzoneMax500mb';
import { PublicacaoParams } from '../../../../interfaces/publicacao.interface';
import { FaPlus } from 'react-icons/fa';
import { listarSecretariasAtivas } from '../../../../api/secretarias';

const InserirBanner: React.FC = () => {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    dataFim: { value: ''; error: boolean };
    imagem: { value: string; error: boolean };
    urlBanner: { value: string; error: boolean };
    creditoAutorImagem: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    altImagem: { value: string; error: boolean };
    ordemBanner: { value: any[]; error: boolean };
    categoriaId: { value: string; error: boolean };
    secretariaId: { value: any[]; error: boolean };
    paginaId: { value: any[]; error: boolean };
    usuarioId: { value: any; error: boolean };
    exigeAprovacao: { value: number; error: boolean };
  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    dataFim: { value: '', error: false },
    imagem: { value: '', error: false },
    urlBanner: { value: '', error: false },
    creditoAutorImagem: { value: '', error: false },
    descricaoImagem: { value: '', error: false },
    altImagem: { value: '', error: false },
    ordemBanner: { value: [], error: false },
    categoriaId: { value: '', error: false },
    secretariaId: { value: [], error: false },
    paginaId: { value: [], error: false },
    usuarioId: { value: null, error: false },
    exigeAprovacao: { value: 0, error: false },
  });

  const [imageBase64, setImageBase64] = useState<string>('');
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [categorias, setCategorias] = useState<any[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [paginas, setPaginas] = useState<any[]>([]);
  const [aprovadores, setAprovadores] = useState<any[]>([]);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [ordemValida, setOrdemValida] = useState(true);
  const [ordemRecomendada, setOrdemRecomendada] = useState<number | null>(null);
  const [selectedPages, setSelectedPages] = useState<number[]>([]);
  const [selectedUser, setSelectedUser] = useState<number | null>(null);
  const [arquivo, setArquivo] = useState<any>();
  const [nomeArquivo, setNomeArquivo] = useState<any>();
  const [typeMidia, setTypeMidia] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [inputValueTagUsuario, setInputValueTagUsuario] = useState('');
  const [tagUsuario, setTagUsuario] = useState<string>('');

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        
        const fetchObterUsuario = async () => {
          try {
           const [data, ativas] = await Promise.all([
             obterUsuario(Number(usuario.seqUsuario)),
             listarSecretariasAtivas()
           ]);
           setSecretarias(
            data.usuarioSecretariaDTO?.length ? data.usuarioSecretariaDTO : ativas
          );
          } catch (error) {
            console.error("Erro ao obter usuario:", error);
          }
        };
  
        fetchObterUsuario();
  
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    fetchCategorias();
    fetchPaginas();
    fetchAprovadoresAtivos();
  }, []);

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await listarExecutores();
      setAprovadores(data);
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  const fetchPaginas = async () => {
    try {
      const data = await api.paginasAtivas();
      setPaginas(data);
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  const validarOrdemAoSair = async (seqPagina: number, numOrdem: string, inputRef: React.RefObject<HTMLInputElement>) => {
    try {
      const ordensExistentes = await api.validarOrdemDisponiveis(seqPagina);

      const numOrdensExistentes = ordensExistentes.map((ordem: any) => ordem.numOrdem);

      if (!numOrdensExistentes.includes(parseInt(numOrdem))) {
        setOrdemValida(true);
        setOrdemRecomendada(null);
      } else {
        setOrdemValida(false);

        setFormValues((prevValues: any) => {
          const updatedOrdemValue = prevValues.ordemBanner.value.map((item: any) => {
            if (item.seqPagina === seqPagina) {
              return { ...item, numOrdem: '' };
            }
            return item;
          });
          return {
            ...prevValues,
            ordemBanner: { value: updatedOrdemValue },
          };
        });

        const recomendada = calcularOrdemRecomendada(ordensExistentes);

        Swal.fire({
          icon: 'warning',
          title: 'Ordem Indisponível',
          text: `A ordem fornecida não está disponível. É recomendado usar o número ${recomendada}`,
          confirmButtonText: 'Fechar',
          willClose: () => {
            setOrdemRecomendada(recomendada);
          },
        });
      }
    } catch (error) {
      console.error('Erro ao validar ordem:', error);
      setOrdemValida(false);
      setOrdemRecomendada(null);
      setErrorMessage('Houve um erro ao validar a ordem. Tente novamente mais tarde.');

      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Houve um erro ao validar a ordem. Tente novamente mais tarde.',
        confirmButtonText: 'Fechar',
      });

      setIsErrorModalOpen(true);
    }
  };

  const calcularOrdemRecomendada = (ordensExistentes: any[]) => {
    const todosNumOrdem = ordensExistentes.map(item => item.numOrdem);
    let recomendada = 1;
    while (todosNumOrdem.includes(recomendada)) {
      recomendada++;
    }
    return recomendada;
  };
    
  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleAddTagUsuario = () => {
    if (inputValueTagUsuario.trim()) {
      setTagUsuario(prevTagUsuario => {
        const newTag = inputValueTagUsuario.trim();
        return prevTagUsuario ? `${prevTagUsuario} ${newTag}` : newTag;
      });
      setInputValueTagUsuario('');
    }
  };

  const handleInputChangeTagUsuario = (e: any) => {
    const value = e.target.value;

    const valueWithoutSpaces = value.replace(/\s/g, '');
    if (valueWithoutSpaces && !valueWithoutSpaces.startsWith('@')) {
      setInputValueTagUsuario(`@${valueWithoutSpaces}`);
    } else {
      setInputValueTagUsuario(valueWithoutSpaces);
    }
  };

  const handleRemoveTagUsuario = (tagToRemove: string) => {
    setTagUsuario(prevTagUsuario => {
      const updatedTags = prevTagUsuario
        .split(' ')
        .filter(tag => tag !== tagToRemove)
        .join(' ');
      return updatedTags.trim();
    });
  };

  const handleCheckboxSecretaria = (codSecretaria: number, checked: boolean) => {
    setSecretariaSelecionada(prev =>
      checked ? Array.from(new Set([...prev, codSecretaria])) : prev.filter(id => id !== codSecretaria)
    );
  
    setFormValues(prev => {
      const current: number[] = Array.isArray(prev?.secretariaId?.value) ? prev.secretariaId.value : [];
      const next = checked
        ? Array.from(new Set([...current, codSecretaria]))
        : current.filter(id => id !== codSecretaria);
  
      return {
        ...prev,
        secretariaId: { ...prev.secretariaId, value: next, error: prev?.secretariaId?.error ?? false },
      };
    });
  };  

  const handleCheckboxChange = (seqPagina: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedPages((prev) => {
      const updatedPages = isChecked ? [...prev, seqPagina] : prev.filter((id) => id !== seqPagina);
      return updatedPages;
    });

    setFormValues((prevValues: any) => {
      const updatedPaginaIdValue = isChecked
        ? [...prevValues.paginaId.value, seqPagina]
        : prevValues.paginaId.value.filter((id: number) => id !== seqPagina);

      let updatedOrdemValue = [...prevValues.ordemBanner.value];
      if (isChecked) {
        updatedOrdemValue.push({ seqPagina, numOrdem: '' });
      } else {
        updatedOrdemValue = updatedOrdemValue.filter((paginaOrdem: any) => paginaOrdem.seqPagina !== seqPagina);
      }

      return {
        ...prevValues,
        paginaId: { value: updatedPaginaIdValue },
        ordemBanner: { value: updatedOrdemValue },
      };
    });
  };

  const handleRadioChange = (seqUsuario: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedUser(isChecked ? seqUsuario : null);

    setFormValues((prevValues: any) => {
      const updatedUsuarioIdValue = isChecked ? seqUsuario : null;

      return {
        ...prevValues,
        usuarioId: { value: updatedUsuarioIdValue },
      };
    });
  };

  const handleInputRadioChange = (field: string, value: any) => {
    if (field === 'exigeAprovacao' && value === 0) {
      setFormValues({
        ...formValues,
        [field]: { error: false, value },
        usuarioId: { value: null, error: false }
      });
    } else {
      setFormValues({
        ...formValues,
        [field]: { error: false, value }
      });
    }
  };

  const handleImageSelected = async (selected: FileWithPath | null) => {
    if (selected) {
      const isImage = selected.type.startsWith("image/");
      const isVideo = selected.type.startsWith("video/");
      const isAudio = selected.type.startsWith("audio/");

      setNomeArquivo(selected.name);
      setTypeMidia(selected.type);
      setArquivo(selected);

      if (isImage || isVideo || isAudio) {
        setArquivoSelecionado(selected);
        setArquivo(selected);

      } else {
        console.error("Tipo de arquivo não suportado.");
      }
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const isFormValid = () => {
    const { titulo, data, creditoAutorImagem, ordemBanner, categoriaId, paginaId, usuarioId, exigeAprovacao } = formValues;
    const isOrdemPreenchida = ordemBanner.value.every((item: any) => item.numOrdem && item.numOrdem !== '0');
  
    if (exigeAprovacao.value == 1) {
      if (!usuarioId.value || usuarioId.value == null) {
        return false;
      }
    }
  
    const isValid = (
      titulo.value &&
      data.value &&
      arquivoSelecionado &&
      creditoAutorImagem.value &&
      ordemBanner.value &&
      categoriaId.value &&
      (paginaId.value.length > 0) &&
      (ordemBanner.value.length > 0) &&
      isOrdemPreenchida &&
      (exigeAprovacao.value == 0 || (exigeAprovacao.value == 1 && usuarioId.value != null))
    );
    
    return isValid && ordemValida;
  };  

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingButton(true);

    const { urlBanner, creditoAutorImagem, descricaoImagem, altImagem, ordemBanner, dataFim, categoriaId, secretariaId, paginaId, usuarioId, data } = formValues;

    if (!ordemValida) {
      setErrorMessage('A ordem fornecida não é válida.');
      setIsErrorModalOpen(true);
    }

    const pendencia = usuarioId.value
      ? {
          codPendencia: 1,
          seqSolicitante: seqUsuario,
          seqExecutor: usuarioId.value,
        }
      : null;

           let codSituacao = 1;
;
  
    if (data.value) {
      const dataDaPublicacao = data.value;
      const diaDeHoje = new Date().toISOString().split("T")[0];

      if (pendencia) {
        codSituacao = 5;
      } else if (dataDaPublicacao > diaDeHoje) {
        codSituacao = 1;
      } else if (dataDaPublicacao === diaDeHoje) {
        codSituacao = 2;
      }  
    } else {
      codSituacao = 2;
    }

    const params: PublicacaoParams = {
      codTipoPublicacao: 3,
      nomePublicacao: formValues.titulo.value || null,
      dscPublicacao: '',
      datPublicacao: formValues.data.value ? formValues.data.value : null,
      datDespublicar: dataFim.value ? formValues.dataFim.value : null,
      seqUsuario: seqUsuario,
      binPublicacao: '',
      urlBin: urlBanner.value || null,
      dscCreditoImagem: creditoAutorImagem.value || null,
      dscDescricaoImagem: descricaoImagem.value || null,
      dscAltImagem: altImagem.value || null,
      seqCategoria: Number(categoriaId.value) || null,
      conteudoPaginaDTO: paginaId.value.map((id: any) => {
        const ordem = ordemBanner.value.find((item: any) => item.seqPagina === Number(id));
        return {
          seqPagina: Number(id),
          numOrdem: ordem ? parseInt(ordem.numOrdem) : null,
        };
      }),
      pendencia: pendencia,
      numAprovacao: pendencia ? 1 : 0,
      dscCitacaoUsuario: tagUsuario,
      numAprovado: 0,
      datInicioEvento: null,
      datFimEvento: null,
      dscHoraInicioEvento: null,
      dscHoraFimEvento: null,
      dscResumo: null,
      dscTags: null,
      numRegistro: 1,
      codSituacaoPubli: codSituacao,
      dscCreditoNoticia: null,
      contasRedeSocial: null,
      dscEnderecoEvento: null,
      conteudoSecretariaDTO: secretariaId.value.map((id: number) => ({
        codSecretaria: id,
      })),
    };

    try {
      if (arquivoSelecionado) {
        const formData = new FormData();
        formData.append("file", arquivoSelecionado);

        const fileExtension = arquivoSelecionado.name.split('.').pop();
        let fileNameToSend = 'banner';

        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }

        const nomePasta = 'publicacoes';

        formData.append("fileName", fileNameToSend);
        formData.append("folderName", nomePasta);

        const cdnData = await api.inserirBannerNoCdn(formData);

        let cdnUrl = "";
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }

        params.binPublicacao = cdnUrl;
      }

      await api.inserirBanner(params);
      setLoadingButton(false);

      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Banner inserido com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/banner');
      });
    } catch (error) {
      setLoadingButton(false);
      console.error('Erro ao inserir banner:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao inserir banner. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/banner');
      });
    }
  };

  return (
    <Flex
      direction="column"
      padding='40px'
      background-color='#fafafa'
      width='100%'
      height={formValues.exigeAprovacao.value === 1 ? '100%' : '100%'}
      overflow='hidden'
    >
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Criar Banner
      </Heading>
      <Box m="40px 0" w="100%">
        <form onSubmit={handleFormSubmit}>
          <div className="row">
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel htmlFor="banner-category" mb="8px">Categoria do Banner</FormLabel>
                <Select
                  id="banner-category"
                  placeholder='Selecione uma Categoria'
                  borderColor="gray.300"
                  _hover={{ borderColor: 'blue.500' }}
                  value={formValues.categoriaId.value}
                  onChange={(e) => handleFieldChange('categoriaId', e.target.value)}
                >
                  {categorias.length > 0 ? (
                    categorias.map(categoria => (
                      <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                        {categoria.dscCategoria}
                      </option>
                    ))
                  ) : (
                    ''
                  )}
                </Select>
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel htmlFor="banner-title" mb="8px">Título da Publicação</FormLabel>
                <CustomInput
                  id="banner-title"
                  placeholder="Digite um título"
                  value={formValues.titulo.value}
                  onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                />
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl>
                <FormLabel htmlFor="banner-url" mb="8px">URL para tornar banner clicável</FormLabel>
                <CustomInput
                  id="banner-url"
                  placeholder="Digite uma URL"
                  value={formValues.urlBanner.value}
                  onChange={(e) => handleFieldChange('urlBanner', e.target.value)}
                />
              </FormControl>
            </div>

            <div className="col-md-3 mb-4">
              <FormControl isRequired>
                <FormLabel mb="8px">Data para Publicação</FormLabel>
                <CustomInput
                  id="banner-publication-date"
                  type="date"
                  value={formValues.data.value}
                  onChange={(e) => handleFieldChange('data', e.target.value)}
                  min={today}
                />
              </FormControl>
            </div>
            <div className="col-md-3 mb-4">
              <FormControl>
                <FormLabel mb="8px">Data fim para Publicação</FormLabel>
                <CustomInput
                  id="banner-unpublish-date"
                  type="date"
                  value={formValues.dataFim.value}
                  onChange={(e) => handleFieldChange('dataFim', e.target.value)}
                  min={today}
                />
              </FormControl>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mb-4">
              <FormControl isRequired>
                <FormLabel mb="8px">Imagem do Banner</FormLabel>
                <ImageDropzoneMax500mb
                  onImageSelected={handleImageSelected}
                  base64={imageBase64}
                  width={1200}
                  height={400}
                  uploadMessage={`Arraste a imagem do banner aqui ou clique para selecionar. <br/>(1200x400 pixels)`}
                />
              </FormControl>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-4">
            <FormControl>
                <FormLabel mb="8px">Tags</FormLabel>
                <div style={{ display: 'flex' }}>
                  <CustomInput
                    value={inputValueTagUsuario}
                    onChange={handleInputChangeTagUsuario}
                    placeholder="Digite uma tag"
                    maxLength={100}
                  />
                  <Button onClick={handleAddTagUsuario} ml="2">
                    <FaPlus />
                  </Button>
                </div>
              </FormControl>

              <div className="rolagem-hashtag mb-3">
                <Wrap spacing="2px">
                  {tagUsuario.trim() && tagUsuario.split(' ').map((tag, index) => (
                    <WrapItem key={index}>
                      <Tag variant="solid" colorScheme="blue" maxW="180px" isTruncated>
                        <TagLabel>{tag}</TagLabel>
                        <TagCloseButton onClick={() => handleRemoveTagUsuario(tag)} />
                      </Tag>
                    </WrapItem>
                  ))}
                </Wrap>
              </div>
              <FormControl>
                <Flex justify="space-between" align="center" mb="8px">
                  <FormLabel mb="8px">
                    Escolha em quais páginas o banner deve aparecer <span style={{ color: 'red' }}>*</span>
                  </FormLabel>
                  <FormLabel mb="8px">
                    Ordem de exibição <span style={{ color: 'red' }}>*</span>
                    <Tooltip label="Ordem a ser utilizada para exibir o banner nas páginas." aria-label="A informação da ordem de exibição">
                    <IconButton
                      className='icones'
                      variant='link'
                      icon={<MdInfoOutline />}
                      aria-label="Informação"
                      size="md"
                      color={'#2883de'} />
                    </Tooltip>
                  </FormLabel>
                </Flex>

                <div className="sidebar-checkbox-pagina">
                  <Stack spacing={5}>
                    {paginas.length > 0 ? (
                      paginas.map((pagina) => {
                        const inputRef = React.createRef<HTMLInputElement>();
                        return (
                          <Flex key={pagina.seqPagina} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                            <Checkbox
                              className="checkPaginas"
                              isChecked={selectedPages.includes(pagina.seqPagina)}
                              onChange={(e) => handleCheckboxChange(pagina.seqPagina, e)}
                            >
                              {pagina.nomPagina}
                            </Checkbox>

                            <div>
                              <CustomInput
                                className="input-ordem-inserir"
                                isDisabled={!selectedPages.includes(pagina.seqPagina)}
                                value={formValues.ordemBanner.value.find((item: any) => item.seqPagina === pagina.seqPagina)?.numOrdem || ''}
                                onChange={(e) => {
                                  const value = e.target.value;

                                  if (value === '') {
                                    setFormValues((prevValues: any) => {
                                      const updatedOrdemValue = prevValues.ordemBanner.value.filter((item: any) => item.seqPagina !== pagina.seqPagina);
                                      return {
                                        ...prevValues,
                                        ordemBanner: { value: updatedOrdemValue },
                                      };
                                    });
                                  } else if (/^\d+$/.test(value) && value !== '0') {
                                    setFormValues((prevValues: any) => {
                                      const updatedOrdemValue = [...prevValues.ordemBanner.value];
                                      const existingOrderIndex = updatedOrdemValue.findIndex((item: any) => item.seqPagina === pagina.seqPagina);

                                      if (existingOrderIndex > -1) {
                                        updatedOrdemValue[existingOrderIndex] = { seqPagina: pagina.seqPagina, numOrdem: value };
                                      } else {
                                        updatedOrdemValue.push({ seqPagina: pagina.seqPagina, numOrdem: value });
                                      }

                                      return {
                                        ...prevValues,
                                        ordemBanner: { value: updatedOrdemValue },
                                      };
                                    });
                                  }
                                }}
                                onBlur={(e) => validarOrdemAoSair(pagina.seqPagina, e.target.value, inputRef)}
                                placeholder="Ordem"
                                ref={inputRef}
                              />
                            </div>
                          </Flex>
                        );
                      })
                    ) : (
                      <p>Não há páginas disponíveis.</p>
                    )}
                  </Stack>
                </div>
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
            {arquivoSelecionado && (
                  <FormControl isRequired mb={'36px'}>
                    <FormLabel mb="8px">Crédito/Autor da imagem</FormLabel>
                    <CustomInput
                      placeholder="Digite um crédito ou autor da imagem"
                      value={formValues.creditoAutorImagem.value}
                      onChange={(e) => handleFieldChange('creditoAutorImagem', e.target.value)}
                    />
                  </FormControl>
                )}
              {arquivoSelecionado && (
                  <>
                    <FormControl mb={'36px'}>
                      <FormLabel mb="8px">Descrição de imagem</FormLabel>
                      <CustomInput
                        placeholder="Digite o texto alternativo da imagem"
                        value={formValues.altImagem.value}
                        onChange={(e) => handleFieldChange('altImagem', e.target.value)}
                      />
                    </FormControl>
                  </>
                )}
              <FormControl className='mb-4'>
              {secretarias.length > 0 && (
                <>
                  <Flex justify="space-between" align="center">
                    <FormLabel mb="8px">
                      Associe o usuário a uma secretaria (opcional)
                    </FormLabel>
                  </Flex>

                  <Box
                    border="1px solid"
                    borderColor="gray.300"
                    borderRadius="md"
                    p={3}
                  >
                    <Box overflow="hidden">
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'center', padding:'8px', borderBottom:'1px solid #ddd' }}></th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Código</th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Secretaria</th>
                          </tr>
                        </thead>
                      </table>
                    </Box>

                    <Box 
                      className="sidebar-checkbox-pagina"
                      overflowX="auto"
                      overflowY={secretarias.length > 5 ? 'auto' : 'visible'}
                      maxH={secretarias.length > 5 ? '240px' : 'unset'}
                    >
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <tbody>
                        {secretarias.map((secretaria: any) => {
                          const cod = Number(secretaria.codSecretaria);
                          const nome = secretaria.secretariasDTO?.dscSecretaria ?? secretaria.dscSecretaria ?? '—';

                          return (
                            <tr key={cod}>
                              <td style={{ textAlign: "center", padding: "8px", borderBottom: "1px solid #ddd" }}>
                                <Checkbox
                                  className="checkCategorias"
                                  isChecked={secretariaSelecionada.includes(cod)}
                                  onChange={(e) => handleCheckboxSecretaria(cod, e.target.checked)}
                                />
                              </td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{cod}</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{nome}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                      </table>
                    </Box>
                  </Box>
                </>
              )}
            </FormControl>
            <div className="row mt-4">
                  <div className="col-md-6 mb-4">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Exige aprovação</FormLabel>
                      <RadioGroup
                        mt={3.5}
                        onChange={(value) => handleInputRadioChange('exigeAprovacao', Number(value))}
                        value={formValues.exigeAprovacao.value.toString()}
                      >
                        <Radio value="1" mr={5}>Sim</Radio>
                        <Radio value="0">Não</Radio>
                      </RadioGroup>
                    </FormControl>
                  </div>

                  {formValues.exigeAprovacao.value === 1 && (
                    <div className="col-md-6 mb-4">
                      <FormControl isRequired>
                        <Flex justify="space-between" align="center" mb="8px">
                          <FormLabel mb="8px">Selecione o aprovador desta publicação</FormLabel>
                        </Flex>
                        <div className={`input-radio-lista ${aprovadores.length === 0 ? 'escondida' : ''}`}>
                          <Stack spacing={5}>
                            {aprovadores.length > 0 ? (
                              aprovadores.map((aprovador: any) => (
                                <Flex key={aprovador.seqUsuario} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                                  <Radio
                                    className="radioAprovadoresNoticia"
                                    value={aprovador.seqUsuario.toString()}
                                    isChecked={selectedUser === aprovador.seqUsuario}
                                    onChange={(e) => handleRadioChange(aprovador.seqUsuario, e)}
                                  >
                                    {aprovador.dscNome}
                                  </Radio>
                                </Flex>
                              ))
                            ) : (
                              <p>Não há lista de aprovadores disponíveis.</p>
                            )}
                          </Stack>
                        </div>
                      </FormControl>
                    </div>
                  )}
                </div>
            </div>

          </div>

          <Flex mt="35px" justifyContent="end">
            <Button
              m="6px"
              onClick={() => navigate('/cms/publicacao/banner')}
            >
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              isDisabled={!isFormValid()}
              isLoading={isLoadingButton}
              loadingText="Criando Banner..."
            >
              {formValues.exigeAprovacao.value === 1
                ? 'Enviar para Aprovação'
                : 'Criar Banner'}            
            </Button>
          </Flex>
        </form>
      </Box>
    </Flex>
  );
};

export default InserirBanner;
